import { Stack, Typography } from '@mui/material';
import { useIsDesktop } from 'Hooks';

interface IDateDivider {
  text: string;
}

export const DateDivider = ({ text }: IDateDivider) => {
  const isDesktop = useIsDesktop();
  return (
    <Stack
      width='100%'
      position='relative'
      height={'25px'}
      alignItems={'center'}
    >
      <Stack
        position={'absolute'}
        top={'12px'}
        height={'1px'}
        bgcolor={'primary.shade_100'}
      />
      <Typography
        minWidth='max-content'
        position='absolute'
        top='50%'
        left='50%'
        bgcolor='white'
        sx={{ transform: 'translate(-50%, -50%)' }}
        variant={'body6'}
      >
        {text}
      </Typography>
    </Stack>
  );
};
